import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-419ce84a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Calculos Generador por Embarque", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  class: "row g-3 needs-validation",
  novalidate: ""
}
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom01",
  class: "form-label"
}, "Fecha", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "operador", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "numero_vuelo", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "No. Embarque", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col d-flex flex-column justify-content-center align-item-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Cargos")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card overflow-scroll" }, [
    /*#__PURE__*/_createElementVNode("table", { class: "table table-hover table-sm" }, [
      /*#__PURE__*/_createElementVNode("thead", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("th", null, "Cargo"),
          /*#__PURE__*/_createElementVNode("th", null, "Monto"),
          /*#__PURE__*/_createElementVNode("th", null, "Estado")
        ])
      ])
    ])
  ])
], -1))

import { Ref, ref, onMounted, computed } from 'vue'
import axios from 'axios'
import { UrlGlobal } from '@/store/dominioGlobal';
import { userGlobalStore } from '@/store/userGlobal';
import { useDateTimeStore } from '@/store/dateTimeStore';
import { Cardeent } from '@/interface/interfaces';
 

export default /*#__PURE__*/_defineComponent({
  __name: 'UpVercalculo',
  props: {
    btnCaUp: Boolean,
    fecha: String,
    operador: String,
    numero_vuelo: String,
    nom_operador: String,
    no_embarque: String,
    confirmado: String,
    fecha_confirma: String,
    hora_confirma: String,

},
  emits: ['updateCaProps'],
  setup(__props, { emit: __emit }) {

const dateTimeStore = useDateTimeStore()
const userStore = userGlobalStore()

const dUrl = UrlGlobal()
//props y emits ----------------------------------------------------------------
const props = __props
const emits = __emit
const handleClick = () => {
    emits("updateCaProps", !props.btnCaUp)
}
//------------------------------------------------------------------------------

//variables reactivas para el formulario----------------------------------------
let fecha = ref(props.fecha)
let operador = ref(props.operador)
let numero_vuelo = ref(props.numero_vuelo)
let no_embarque = ref(props.no_embarque)
let id: any
let tarifa: any
let nom_tarifa: any
let monto: any
let status: any
let nom_status: any
let id_ref = String
 
//------------------------------------------------------------------------------
const cardeent = ref<Array<Cardeent>>([])
const getCardeent = (id_no_embarque: any, id_numero_vuelo: any, id_operador: any, id_fecha: any, id: any) => {
        fecha = id_fecha
        operador = id_operador
        numero_vuelo = id_numero_vuelo
        no_embarque = id_no_embarque 
         
        axios.get(`${dUrl.urlGlobal}/api2/cardeent/mostrar?id_no_embarque=${id_no_embarque}&id_numero_vuelo=${id_numero_vuelo}&id_operador=${id_operador}&id_fecha=${id_fecha}`)
        //axios.get(final)    
            .then(response => { //console.log(response.data)
                cardeent.value = response.data;
                console.log(response.data)
                
            })
            .catch(error => {
                console.error('Error buscando detalles de manifiesto:', error);
        });
    }

const filteredCarga1 = () => {
    
    return cardeent.value.filter(elm => {
        return (
            elm.id?.toLocaleLowerCase().valueOf ||
            elm.tarifa?.toLocaleLowerCase().valueOf ||
            elm.monto?.toLocaleLowerCase().valueOf ||
            elm.status?.toLocaleLowerCase().valueOf)
                   
})
}

const handleSubmit = async () => {
     
    emits("updateCaProps", !props.btnCaUp)
    
}

onMounted(() => {
    getCardeent("fecha", "operador", "numero_vuelo", "no_embarque", null);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom01",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fecha) ? (fecha).value = $event : fecha = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(fecha)]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(operador) ? (operador).value = $event : operador = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(operador)]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(numero_vuelo) ? (numero_vuelo).value = $event : numero_vuelo = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(numero_vuelo)]
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "validationCustom02",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(no_embarque) ? (no_embarque).value = $event : no_embarque = $event)),
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, _unref(no_embarque)]
          ]),
          _hoisted_17
        ])
      ]),
      _hoisted_18
    ])
  ], 64))
}
}

})